var alignment_rtlignore_default = {
  "alignLeft": "EzHwC",
  "textWrapNowrap": "_7L24Q",
  "alignRight": "_6ertq",
  "alignCenter": "dc9Ry",
  "sizeFullWidth": "WATUI",
  "renderedInTable": "PRATX",
  "sizeOriginal": "_67ms9",
  "sizeContent": "_21xWZ",
  "sizeSmall": "tDwdK",
  "sizeSmallCenter": "yz5PQ",
  "flex": "AzD1j",
  "LEFT": "T6zOd",
  "CENTER": "ZZK1Z",
  "RIGHT": "_1qDRR",
  "AUTO": "lbOW6",
  "JUSTIFY": "J0Hwa"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
